import { render, staticRenderFns } from "./ReceiptEdit.vue?vue&type=template&id=5707b5e1&scoped=true"
import script from "./ReceiptEdit.vue?vue&type=script&lang=js"
export * from "./ReceiptEdit.vue?vue&type=script&lang=js"
import style0 from "./ReceiptEdit.vue?vue&type=style&index=0&id=5707b5e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707b5e1",
  null
  
)

export default component.exports